<template>
  <div>
  <nav class="navMenu" v-bind:style="{ height: menuHeight }">
    <el-menu
      ref="navMenu"
      :router="true"
      unique-opened
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-submenu index="1" v-if="hasPermission('contract')">
        <template slot="title">
          <i class="fas fa-sign-out-alt" />
          <span>{{ $t("title.contract_management") }}</span>
        </template>
        <el-menu-item
          index="/sale/estimation"
          v-if="hasPermission('estimation')"
          ><AMenuItem
            :pageUrl="'/sale/estimation'"
            :title="this.$t('title.estimation')"
        /></el-menu-item>
        <el-menu-item
          index="/sale/contract_reg"
          v-if="hasPermission('contract_reg')"
          ><AMenuItem
            :pageUrl="'/sale/contract_reg'"
            :title="this.$t('title.contract_reg')"
        /></el-menu-item>
        <el-menu-item
          index="/sale/contract"
          v-if="hasPermission('contract_stat')"
          ><AMenuItem
            :pageUrl="'/sale/contract'"
            :title="this.$t('title.contract')"
        /></el-menu-item>
        <el-menu-item
          index="/sale/contract_cancel"
          v-if="hasPermission('contract_cancel')"
          ><AMenuItem
            :pageUrl="'/sale/contract_cancel'"
            :title="this.$t('title.contract_cancel')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="2" v-if="hasPermission('production')">
        <template slot="title">
          <i class="fas fa-cogs" />
          <span>{{ $t("title.production") }}</span>
        </template>
        <el-menu-item
          index="/sale/production"
          v-if="hasPermission('production_plan')"
          ><AMenuItem
            :pageUrl="'/sale/production'"
            :title="this.$t('title.production_plan')"
        /></el-menu-item>
        <el-menu-item
          index="/production/process"
          v-if="hasPermission('production_result')"
          ><AMenuItem
            :pageUrl="'/production/process'"
            :title="this.$t('title.production_result')"
        /></el-menu-item>
        <el-menu-item
          index="/production/pack"
          v-if="hasPermission('production_pack')"
          ><AMenuItem
            :pageUrl="'/production/pack'"
            :title="this.$t('title.production_pack')"
        /></el-menu-item>
        <el-menu-item
          index="/production/shipment"
          v-if="hasPermission('production_shipment')"
          ><AMenuItem
            :pageUrl="'/production/shipment'"
            :title="this.$t('title.production_shipment')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="3" v-if="hasPermission('sale')">
        <template slot="title">
          <i class="fas fa-chart-area"></i>
          <span>{{ $t("title.sale") }}</span>
        </template>
        <el-menu-item index="/sale/sale" v-if="hasPermission('sale_reg')"
          ><AMenuItem :pageUrl="'/sale/sale'" :title="this.$t('title.sale_reg')"
        /></el-menu-item>
        <el-menu-item index="/sale/orders" v-if="hasPermission('sale_orders')"
          ><AMenuItem
            :pageUrl="'/sale/orders'"
            :title="this.$t('title.sale_orders')"
        /></el-menu-item>
        <el-menu-item index="/sale/ledger" v-if="hasPermission('sale_ledger')"
          ><AMenuItem
            :pageUrl="'/sale/ledger'"
            :title="this.$t('title.sale_ledger')"
        /></el-menu-item>
        <!-- <el-menu-item index="/sale/trade">- {{ $t("title.trade") }}</el-menu-item>         -->
        <el-menu-item
          index="/sale/uncollected"
          v-if="hasPermission('uncollected')"
          ><AMenuItem
            :pageUrl="'/sale/uncollected'"
            :title="this.$t('title.uncollected')"
        /></el-menu-item>
        <el-menu-item
          index="/sale/collect_stat"
          v-if="hasPermission('collect_stat')"
          ><AMenuItem
            :pageUrl="'/sale/collect_stat'"
            :title="this.$t('title.collect_stat')"
        /></el-menu-item>
        <el-menu-item index="/sale/collect" v-if="hasPermission('collection')"
          ><AMenuItem
            :pageUrl="'/sale/collect'"
            :title="this.$t('title.collection')"
        /></el-menu-item>
        <el-menu-item index="/sale/sale_stat" v-if="hasPermission('sale_stat')"
          ><AMenuItem
            :pageUrl="'/sale/sale_stat'"
            :title="this.$t('title.sale_stat')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="4" v-if="hasPermission('buy')">
        <template slot="title">
          <i class="fas fa-sign-in-alt" />
          <span>{{ $t("title.buy") }}</span>
        </template>
        <el-menu-item index="/buy/order_reg" v-if="hasPermission('order_reg')"
          ><AMenuItem
            :pageUrl="'/buy/order_reg'"
            :title="this.$t('title.order_reg')"
        /></el-menu-item>
        <el-menu-item index="/buy/order" v-if="hasPermission('order')"
          ><AMenuItem :pageUrl="'/buy/order'" :title="this.$t('title.order')"
        /></el-menu-item>
        <el-menu-item index="/buy/inbound" v-if="hasPermission('inbound')"
          ><AMenuItem
            :pageUrl="'/buy/inbound'"
            :title="this.$t('title.inbound')"
        /></el-menu-item>
        <el-menu-item index="/buy/orders" v-if="hasPermission('orders')"
          ><AMenuItem :pageUrl="'/buy/orders'" :title="this.$t('title.orders')"
        /></el-menu-item>
        <el-menu-item index="/buy/buy" v-if="hasPermission('order_stat')"
          ><AMenuItem :pageUrl="'/buy/buy'" :title="this.$t('title.order_stat')"
        /></el-menu-item>
        <el-menu-item index="/buy/unpaid" v-if="hasPermission('unpaid')"
          ><AMenuItem :pageUrl="'/buy/unpaid'" :title="this.$t('title.unpaid')"
        /></el-menu-item>
        <el-menu-item index="/buy/ledger" v-if="hasPermission('buy_ledger')"
          ><AMenuItem
            :pageUrl="'/buy/ledger'"
            :title="this.$t('title.buy_ledger')"
        /></el-menu-item>
        <el-menu-item index="/buy/pay_stat" v-if="hasPermission('pay_stat')"
          ><AMenuItem
            :pageUrl="'/buy/pay_stat'"
            :title="this.$t('title.pay_stat')"
        /></el-menu-item>
        <el-menu-item index="/buy/pay" v-if="hasPermission('pay')"
          ><AMenuItem :pageUrl="'/buy/pay'" :title="this.$t('title.pay')"
        /></el-menu-item>
        <el-menu-item index="/buy/buy_stat" v-if="hasPermission('buy_stat')"
          ><AMenuItem
            :pageUrl="'/buy/buy_stat'"
            :title="this.$t('title.buy_stat')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="5" v-if="hasPermission('stock')">
        <template slot="title">
          <i class="fas fa-box" />
          <span>{{ $t("lang.title_material") }}</span>
        </template>
        <el-menu-item index="/stock/stock" v-if="hasPermission('stock_manage')"
          ><AMenuItem
            :pageUrl="'/stock/stock'"
            :title="this.$t('lang.title_stock')"
        /></el-menu-item>
        <el-menu-item
          index="/stock/stock_history"
          v-if="hasPermission('stock_history')"
          ><AMenuItem
            :pageUrl="'/stock/stock_history'"
            :title="this.$t('lang.title_stock_history')"
        /></el-menu-item>
        <el-menu-item
          index="/stock/inbound"
          v-if="hasPermission('stock_inbound')"
          ><AMenuItem
            :pageUrl="'/stock/inbound'"
            :title="this.$t('lang.title_inbound')"
        /></el-menu-item>
        <el-menu-item index="/stock/serial" v-if="hasPermission('serial')"
          ><AMenuItem
            :pageUrl="'/stock/serial'"
            :title="this.$t('title.serial')"
        /></el-menu-item>
        <el-menu-item index="/stock/good" v-if="hasPermission('good')"
          ><AMenuItem :pageUrl="'/stock/good'" :title="this.$t('title.good')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="6" v-if="hasPermission('invoice')">
        <template slot="title">
          <i class="fas fa-file-alt"></i>
          <span>{{ $t("title.invoice") }}</span>
        </template>
        <el-menu-item index="/buy/invoice" v-if="hasPermission('buy_invoice')"
          ><AMenuItem :pageUrl="'/buy/invoice'" :title="'매입세금계산서'"
        /></el-menu-item>
        <el-menu-item index="/sale/invoice" v-if="hasPermission('sale_invoice')"
          ><AMenuItem :pageUrl="'/sale/invoice'" :title="'매출세금계산서'"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="7" v-if="hasPermission('asset')">
        <template slot="title">
          <i class="fas fa-coins" />
          <span>{{ $t("title.asset") }}</span>
        </template>
        <el-menu-item index="/asset/account" v-if="hasPermission('account')"
          ><AMenuItem
            :pageUrl="'/asset/account'"
            :title="this.$t('title.account')"
        /></el-menu-item>
        <el-menu-item
          index="/asset/asset_category"
          v-if="hasPermission('asset_category')"
          ><AMenuItem
            :pageUrl="'/asset/asset_category'"
            :title="this.$t('title.asset_category')"
        /></el-menu-item>
        <el-menu-item index="/asset/asset_reg" v-if="hasPermission('asset_reg')"
          ><AMenuItem
            :pageUrl="'/asset/asset_reg'"
            :title="this.$t('title.asset_reg')"
        /></el-menu-item>
        <el-menu-item
          index="/asset/asset_status"
          v-if="hasPermission('asset_status')"
          ><AMenuItem
            :pageUrl="'/asset/asset_status'"
            :title="this.$t('title.asset_status')"
        /></el-menu-item>
        <el-menu-item index="/sale/note" v-if="hasPermission('note')"
          ><AMenuItem :pageUrl="'/sale/note'" :title="this.$t('title.note')"
        /></el-menu-item>
        <el-menu-item
          index="/asset/settlement"
          v-if="hasPermission('settlement')"
          ><AMenuItem
            :pageUrl="'/asset/settlement'"
            :title="this.$t('title.settlement')"
        /></el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="6" v-if="hasPermission('management')">
        <template slot="title">
          <i class="fas fa-building" />
          <span>{{ $t("lang.title_management") }}</span>
        </template>
        <el-menu-item index="/management/r_note">{{ $t("lang.title_receivablenote") }}</el-menu-item>
        <el-menu-item index="/management/p_note">{{ $t("lang.title_purchasenote") }}</el-menu-item>
      </el-submenu> -->

      <el-submenu index="8" v-if="hasPermission('base')">
        <template slot="title">
          <i class="fas fa-database" />
          <span>
            {{ $t("lang.title_base") }}
            <!-- <router-link to="/base/">{{ $t("lang.title_base") }}</router-link> -->
          </span>
        </template>
        <el-menu-item index="/base/code" v-if="hasPermission('code')"
          ><AMenuItem
            :pageUrl="'/base/code'"
            :title="this.$t('lang.title_code')"
        /></el-menu-item>
        <el-menu-item index="/base/customer" v-if="hasPermission('customer')"
          ><AMenuItem
            :pageUrl="'/base/customer'"
            :title="this.$t('lang.title_customer')"
        /></el-menu-item>
        <el-menu-item
          index="/base/customer_level"
          v-if="hasPermission('customer_level')"
          ><AMenuItem
            :pageUrl="'/base/customer_level'"
            :title="this.$t('title.customer_level')"
        /></el-menu-item>
        <el-menu-item
          index="/base/client_level"
          v-if="hasPermission('client_level')"
          ><AMenuItem
            :pageUrl="'/base/client_level'"
            :title="this.$t('title.client_level')"
        /></el-menu-item>
        <el-menu-item
          index="/base/product_type"
          v-if="hasPermission('product_type')"
          ><AMenuItem
            :pageUrl="'/base/product_type'"
            :title="this.$t('title.product_type')"
        /></el-menu-item>
        <el-menu-item
          index="/base/product_category"
          v-if="hasPermission('product_category')"
          ><AMenuItem
            :pageUrl="'/base/product_category'"
            :title="this.$t('title.product_category')"
        /></el-menu-item>
        <el-menu-item index="/base/product" v-if="hasPermission('product')"
          ><AMenuItem
            :pageUrl="'/base/product'"
            :title="this.$t('lang.title_product')"
        /></el-menu-item>
        <el-menu-item index="/base/cost" v-if="hasPermission('cost')"
          ><AMenuItem
            :pageUrl="'/base/cost'"
            :title="this.$t('lang.title_cost')"
        /></el-menu-item>
        <el-menu-item index="/base/glass" v-if="hasPermission('glass')"
          ><AMenuItem :pageUrl="'/base/glass'" :title="this.$t('title.glass')"
        /></el-menu-item>
        <el-menu-item index="/base/door" v-if="hasPermission('door')"
          ><AMenuItem :pageUrl="'/base/door'" :title="this.$t('title.door')"
        /></el-menu-item>
        <el-menu-item index="/base/bom" v-if="hasPermission('bom')"
          ><AMenuItem :pageUrl="'/base/bom'" :title="this.$t('title.bom')"
        /></el-menu-item>
        <el-menu-item index="/base/option" v-if="hasPermission('option')"
          ><AMenuItem
            :pageUrl="'/base/option'"
            :title="this.$t('title.goods_option')"
        /></el-menu-item>
        <el-menu-item index="/base/area" v-if="hasPermission('area')"
          ><AMenuItem :pageUrl="'/base/area'" :title="this.$t('title.area')"
        /></el-menu-item>
        <el-menu-item index="/base/company" v-if="hasPermission('company')"
          ><AMenuItem
            :pageUrl="'/base/company'"
            :title="this.$t('lang.title_company')"
        /></el-menu-item>
      </el-submenu>

      <el-submenu index="9" v-if="hasPermission('schedule')">
        <template slot="title">
          <i class="fas fa-calendar-alt" />
          <span>{{ $t("title.schedule") }}</span>
        </template>
        <el-menu-item
          index="/schedule/dashboard"
          v-if="hasPermission('dashboard')"
          ><AMenuItem
            :pageUrl="'/schedule/dashboard'"
            :title="this.$t('title.dashboard')"
        /></el-menu-item>
        <el-menu-item
          index="/schedule/schedule"
          v-if="hasPermission('total_schedule')"
          ><AMenuItem
            :pageUrl="'/schedule/schedule'"
            :title="this.$t('title.integrated_schedule')"
        /></el-menu-item>
        <el-menu-item index="/service/service" v-if="hasPermission('as')"
          ><AMenuItem :pageUrl="'/service/service'" :title="this.$t('title.as')"
        /></el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="5" v-if="hasPermission('as')">
        <template slot="title">
          <i class="fas fa-user-cog" />
          <span>{{ $t("title.as") }}</span>
        </template>
        <el-menu-item index="/as/service_reg">{{ $t("title.as_reg") }}</el-menu-item> 
        <el-menu-item index="/service/service">{{ $t("title.as") }}</el-menu-item>
      </el-submenu>  -->

      <el-submenu index="10" v-if="hasPermission('system')">
        <template slot="title">
          <i class="fas fa-tools" />
          <span>{{ $t("lang.title_system") }}</span>
        </template>
        <el-menu-item index="/system/user" v-if="hasPermission('user')"
          ><AMenuItem
            :pageUrl="'/system/user'"
            :title="this.$t('lang.title_user')"
        /></el-menu-item>
        <el-menu-item index="/system/group" v-if="hasPermission('group')"
          ><AMenuItem
            :pageUrl="'/system/group'"
            :title="this.$t('lang.title_group')"
        /></el-menu-item>
        <el-menu-item index="/system/branch" v-if="hasPermission('branch')"
          ><AMenuItem
            :pageUrl="'/system/branch'"
            :title="this.$t('title.branch')"
        /></el-menu-item>
        <el-menu-item index="/system/notice" v-if="hasPermission('notice')"
          ><AMenuItem
            :pageUrl="'/system/notice'"
            :title="this.$t('title.notice')"
        /></el-menu-item>
        <el-menu-item index="/base/history" v-if="hasPermission('history')"
          ><AMenuItem
            :pageUrl="'/base/history'"
            :title="this.$t('lang.title_history')"
        /></el-menu-item>
      </el-submenu>
    </el-menu>
  </nav>
  <button class="site-as-fab" @click="openSiteAS" title="사이트 A/S 접수">
    <i class="fas fa-bug" /> 사이트 A/S 접수
  </button>
  <el-dialog
    title="사이트 A/S 접수"
    :visible.sync="asDialogVisible"
    width="420px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @closed="_onASDialogClosed"
  >
    <span>현재 화면을 캡쳐하여 접수하시겠습니까?</span>
    <span slot="footer">
      <el-button type="primary" @click="_asDialogClose('capture')">화면 캡쳐</el-button>
      <el-button @click="_asDialogClose('nocapture')">캡쳐 안함</el-button>
      <el-button @click="_asDialogClose('cancel')">취소</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { domToBlob } from "modern-screenshot";
import { mapGetters } from "vuex";
import AMenuItem from "@/shared/AMenuItem";

export default {
  name: "navMenu",
  components: { AMenuItem },
  data() {
    return {
      menuHeight: "100%",
      asDialogVisible: false,
      asDialogResolve: null,
      asDialogAction: null,
    };
  },
  props: {
    height: {
      type: Number,
    },
  },
  watch: {
    height: function(val) {
      this.menuHeight = val + "px";
    },
  },
  computed: {
    ...mapGetters([
      "userData",
      "userName",
      "table_user_group",
      "table_user_authority",
    ]),
  },
  methods: {
    _showASCaptureDialog() {
      return new Promise((resolve) => {
        this.asDialogResolve = resolve;
        this.asDialogVisible = true;
      });
    },
    _asDialogClose(action) {
      this.asDialogAction = action;
      this.asDialogVisible = false;
    },
    async _onASDialogClosed() {
      if (!this.asDialogResolve) return;
      const resolve = this.asDialogResolve;
      const action = this.asDialogAction || "cancel";
      this.asDialogResolve = null;
      this.asDialogAction = null;

      const blob = action === "capture" ? await this._captureScreen() : null;
      resolve({ action, blob });
    },

    async openSiteAS() {
      const { action, blob } = await this._showASCaptureDialog();
      if (action === "cancel") return;
      const { account, name } = this.userData;

      const newTab = window.open("about:blank", "_blank");
      if (!newTab) {
        alert("팝업이 차단되었습니다. 팝업 허용 후 다시 시도해 주세요.");
        return;
      }

      try {
        const formData = new FormData();
        if (blob) formData.append("screenshot", blob, "screenshot.png");
        formData.append("pagePath", this.$route.path);
        formData.append("sourceUrl", window.location.href);
        formData.append("chargerAccount", account);
        formData.append("chargerName", name);

        const res = await fetch(
          `${process.env.VUE_APP_NEXT_APP_URL}/api/external/bug_report`,
          { method: "POST", body: formData },
        );
        const data = await res.json();

        if (!data.ok || !data.loginUrl) {
          newTab.close();
          alert("A/S 접수 페이지를 열 수 없습니다. 잠시 후 다시 시도해 주세요.");
          return;
        }

        newTab.location.href =
          `${process.env.VUE_APP_NEXT_APP_URL}${data.loginUrl}`;
      } catch (err) {
        newTab.close();
        alert("A/S 접수 페이지를 열 수 없습니다. 잠시 후 다시 시도해 주세요.");
        console.error(err);
      }
    },

    async _captureScreen() {
      const target = document.getElementById("app") || document.documentElement;
      const scale = window.devicePixelRatio;

      // 스크롤된 요소를 직접 DOM 수정으로 "고정" (cloneNode 이전에 적용)
      const restoreList = [];
      target.querySelectorAll("*").forEach((el) => {
        const st = el.scrollTop;
        const sl = el.scrollLeft;
        if (!st && !sl) return;

        const savedOverflow = el.style.overflow;
        const wrapper = document.createElement("div");
        if (st) wrapper.style.marginTop = `-${st}px`;
        if (sl) wrapper.style.marginLeft = `-${sl}px`;

        el.style.overflow = "hidden";
        Array.from(el.childNodes).forEach((child) => wrapper.appendChild(child));
        el.appendChild(wrapper);

        restoreList.push(() => {
          Array.from(wrapper.childNodes).forEach((child) => el.insertBefore(child, wrapper));
          wrapper.remove();
          el.style.overflow = savedOverflow;
          el.scrollTop = st;
          el.scrollLeft = sl;
        });
      });

      const blob = await domToBlob(target, {
        scale,
        width: target.offsetWidth,
        height: target.offsetHeight,
        filter: (node) => {
          if (node.nodeType !== 1) return true;
          if (node.tagName === "NOSCRIPT") return false;
          const cls = node.classList;
          if (!cls) return true;
          if (cls.contains("site-as-fab")) return false;
          if (cls.contains("el-message-box__wrapper")) return false;
          if (cls.contains("v-modal")) return false;
          if (cls.contains("el-overlay")) return false;
          return true;
        },
      });

      restoreList.forEach((fn) => fn());
      return blob;
    },
    hasPermission(path) {
      if (!this.userData) {
        return false;
      }
      let user_group_id = this.userData.user_group_id;
      let group = this.table_user_group.find(
        (item) => item.id === user_group_id
      );
      // 사용자 그룹명이 '최고관리자' 가 아니면,
      // '사용자관리' & '사용자그룹관리' 메뉴를 disable
      if (!group) {
        return false;
      }

      // 계정 정보가 'erp' 와 최고관리자인 '최고 권한 그룹' 정보가 'Y'인 경우
      if (group.super_group_tag === "Y") {
        return true;
      }

      let authority = this.table_user_authority.find(
        (item) => item.name === path
      );
      if (!authority) {
        return false;
      }

      // if (group.name !== '최고관리자' && (path === 'user' || path === 'group')) {
      //   return false;
      // }
      // 상위 메뉴일 때
      if (authority.depth === 1) {
        // 상위 메뉴에 속하는 하위 메뉴들을 가져옴
        let child_auth_items = this.table_user_authority.filter(
          (item) => item.parent_id === authority.id
        );
        let ret_value = false;
        // 하위 메뉴들의 level 값이 모두 '0' 이면, 상위 메뉴를 disable
        // 하위 메뉴 중 하나라도 level 값이 '1' 이상이면 상위 메뉴를 enable
        for (var i = 0; i < child_auth_items.length; i++) {
          // 사용자 그룹명이 '최고관리자' 가 아니면,
          // '사용자관리' & '사용자그룹관리' 메뉴를 disable 처리하므로 level 값 확인하지 않음
          if (
            child_auth_items[i].name === "user" ||
            child_auth_items[i].name === "group"
          ) {
            continue;
          }
          let auth_item = group.authorities.find(
            (findItem) => findItem.user_authority_id === child_auth_items[i].id
          );
          if (auth_item !== undefined && auth_item.level) {
            ret_value = true;
            break;
          }
        }
        return ret_value;
      } else {
        // 하위 메뉴일 때 현재 메뉴의 level 값을 구하여,
        // level 값이 모두 '0' 이면, 상위 메뉴를 disable
        // level 값이 '1' 이상이면 상위 메뉴를 enable
        let auth_item = group.authorities.find(
          (item) => item.user_authority_id === authority.id
        );
        return auth_item !== undefined && auth_item.level;
      }
    },
    // initMenu() {
    //   const current = this.$route.path;
    //   this.active = "";
    //   for (var s in this.$refs.navMenu.submenus) {
    //     const sub = this.$refs.navMenu.submenus[s];
    //     for (var i in sub.items) {
    //       const item = sub.items[i];
    //       if (!item.route) continue;
    //       if (item.route === current) {
    //         this.active = item.index;
    //       }
    //       if (this.active) break;
    //     }
    //     if (this.active) break;
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo {
  height: 100%;
}

.el-submenu .el-menu-item {
  height: 30px;
  line-height: 30px;
}


.site-as-fab {
  position: fixed;
  bottom: 12px;
  left: 0px;
  padding: 0 16px;
  z-index: 9999;
  background-color: transparent;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.borderline:after {
  content: "";
  margin: 0 20px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: 1px solid white;
}
</style>
